import React from 'react';
import { Modal as AntdModal } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import styled, { ITheme } from 'styled-components';
import { CircleCloseIcon } from 'src/components/Icons';
import { modalSelector } from './Modal.selector';
import { actionCloseModal } from './Modal.actions';

export const Wrapper = styled.div`
    padding: 32px;
    border-radius: 6px;
    display: flex;
    flex-direction: column;
    align-items: center;
    background-color: ${({ theme }: { theme: ITheme }) => theme.dark1};
    > div {
        width: 100%;
    }
    .btn-close {
        margin: auto 0 -46px auto;
        z-index: 99;
    }
    .header-title {
        // margin: auto;
        font-style: normal;
        font-size: 32px;
        // text-align: start;
        width: 100%;
    }
`;

const Modal = React.memo(() => {
    const dispatch = useDispatch();
    const { visible, data, width, title, onClose, autoClose, customModal } = useSelector(modalSelector);
    const handleClose = () => {
        dispatch(actionCloseModal());
        typeof onClose === 'function' && onClose();
    };
    React.useEffect(() => {
        if (autoClose) {
            setTimeout(() => {
                handleClose();
            }, 2000);
        }
    }, [autoClose]);
    if (!data) return null;
    if (customModal) {
        return (
            <AntdModal visible={visible} destroyOnClose footer={null} width={width} onCancel={handleClose}>
                {data}
            </AntdModal>
        );
    }
    return (
        <AntdModal visible={visible} destroyOnClose footer={null} width={width} onCancel={handleClose}>
            <Wrapper>
                <CircleCloseIcon onClick={handleClose} className="btn-close" />
                {!!title && <p className="fw-bold fs-verylarge disable-pointer gradient-text header-title">{title}</p>}
                {data}
            </Wrapper>
        </AntdModal>
    );
});

export default Modal;
